import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { 
  Settings, 
  Database, 
  Key, 
  BarChart3,
  Download,
  Trash2,
  Server,
  Users,
  Package,
  Palette,
  ShieldAlert,
  FlaskConical,
  FileText
} from 'lucide-react';
import ApiConfigs from '../components/admin/ApiConfigs';
import SystemSettings from '../components/admin/SystemSettings';
import ThemeSettings from '../components/admin/ThemeSettings';
import Statistics from '../components/admin/Statistics';
import DataExport from '../components/admin/DataExport';
import Maintenance from '../components/admin/Maintenance';
import Resellers from '../components/admin/Resellers';
import Products from '../components/admin/Products';
import LoginBlocks from '../components/admin/LoginBlocks';
import Testing from '../components/admin/Testing';
import LoginLogs from '../components/admin/LoginLogs';

const Admin = () => {
  const location = useLocation();

  const navigation = [
    { name: 'Resellers', href: '/admin/resellers', icon: Users },
    { name: 'Products', href: '/admin/products', icon: Package },
    { name: 'Login Logs', href: '/admin/login-logs', icon: FileText },
    { name: 'Login Blocks', href: '/admin/login-blocks', icon: ShieldAlert },
    { name: 'API Configs', href: '/admin/api-configs', icon: Key },
    { name: 'Testing', href: '/admin/testing', icon: FlaskConical },
    { name: 'Theme', href: '/admin/theme', icon: Palette },
    { name: 'Settings', href: '/admin/settings', icon: Settings },
    { name: 'Statistics', href: '/admin/statistics', icon: BarChart3 },
    { name: 'Data Export', href: '/admin/export', icon: Download },
    { name: 'Maintenance', href: '/admin/maintenance', icon: Trash2 },
  ];

  const isActivePath = (path) => {
    return location.pathname === path || 
           (path === '/admin/resellers' && location.pathname === '/admin');
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-white">Admin Panel</h1>
        <p className="mt-1 text-sm text-gray-400">
          Manage system configuration and settings
        </p>
      </div>

      {/* Navigation Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                  isActivePath(item.href)
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon className="mr-2 h-5 w-5" />
                {item.name}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Content */}
      <div className="mt-6">
        <Routes>
          <Route index element={<Resellers />} />
          <Route path="resellers" element={<Resellers />} />
          <Route path="products" element={<Products />} />
          <Route path="login-logs" element={<LoginLogs />} />
          <Route path="login-blocks" element={<LoginBlocks />} />
          <Route path="api-configs" element={<ApiConfigs />} />
          <Route path="testing" element={<Testing />} />
          <Route path="theme" element={<ThemeSettings />} />
          <Route path="settings" element={<SystemSettings />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="export" element={<DataExport />} />
          <Route path="maintenance" element={<Maintenance />} />
        </Routes>
      </div>
    </div>
  );
};

export default Admin;
